/**
 * Lightweight presence hint for the HttpOnly refresh cookie. We can't read
 * the cookie from JS, but we can remember "this browser was signed in"
 * locally so the bootstrap on a fresh tab can skip the `/auth/me` round trip
 * for guests. The flag is only a hint — server-side checks remain
 * authoritative.
 *
 * Why this exists: without it, every public-page navigation (Home, Login,
 * Forgot) wakes up the API just to learn the user is anonymous. That call
 * shows up as a console error during Lighthouse audits and adds avoidable
 * latency on cold loads.
 */
const KEY = 'sarraf:auth-hint';

export function hasAuthHint(): boolean {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    // Storage blocked (private mode, quota) — fall back to optimistic
    // hydrate so we don't lock the user out.
    return true;
  }
}

export function setAuthHint(value: boolean): void {
  try {
    if (value) localStorage.setItem(KEY, '1');
    else localStorage.removeItem(KEY);
  } catch {
    // Ignore — storage failures don't affect auth correctness.
  }
}
